import { gql } from "../../../../../gql/__generated__/gql";

export const SIGN_UP_NEW_USER = gql(`
  mutation signUpNewUser($input: SignUpNewUserInput!) {
    signUpNewUser(input: $input)
  }
`);

export const SEND_PASSWORD_RESET_EMAIL = gql(`
  mutation sendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email)
  }
`);

export const UPDATE_USER = gql(`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      email
      userType
      validated
      createdAt
      updatedAt
      name
      description
      categories
      imageUrl
      brandId
      rating
      completedCollabs
      monthlyGMV
      socialMedia {
        tiktok
        instagram
        youtube
        twitter
      }
      stripeAccountId
      stripeBankAccountId
      payoutsEnabled
    }
  }
`);
